module.exports = __webpack_public_path__ + "img/gzh.c77775cf.png";